import { render, staticRenderFns } from "./main-section-secondary.vue?vue&type=template&id=6eb47a02&scoped=true"
import script from "./main-section-secondary.vue?vue&type=script&lang=js"
export * from "./main-section-secondary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb47a02",
  null
  
)

export default component.exports